import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { ConsultantDTO } from "./AddConsultant";

type AddConsultantResponse = ConsultantDTO & ApiError;

export const EditConsultant = (
  data: ConsultantDTO,
  id: string
): Promise<AddConsultantResponse> => {
  return axios
    .patch(`/consultant/${id}`, data)
    .then((response) => response.data as AddConsultantResponse);
};
